import Helmet from "react-helmet";
import './style.scss';
import { useHistory } from "react-router-dom";

function NotFound(props: {message?: string}) {
    const history = useHistory();

    return (
        <div id="content">
            <Helmet>
                <title>Page Not Found</title>
                <meta name="description" content="Page Not Found"/>
            </Helmet>
            {/* Heading */}
            <div className='not-found'>
                <h2>Page Not Found</h2>
                <p>{props.message || 'or Optional Feature has not been Enabled'}</p>
                {props.message ? <span onClick={() => history.go(0)}>Try Again</span> : <span onClick={() => history.push('/')}>Return to home page</span>}
            </div>
        </div>
    );
}


export default NotFound;
